import { FeatureTogglePort } from '@otto-ec/eprivacy-shared'

export const IS_ONETRUST_ENABLED_TOGGLE_KEY = 'cb_enable_onetrust'

export function isOneTrustEnabled(featureTogglePort: FeatureTogglePort) {
  return featureTogglePort(IS_ONETRUST_ENABLED_TOGGLE_KEY, true)
}
